var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[(_vm.data.isSvg)?_c('SvgGridOverlay',{attrs:{"data":_vm.data}}):_c('CommonOverlay',{attrs:{"data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }